import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { string, array, func } from 'prop-types';
import {
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';

class StatisticsTZSelector extends Component {
  static propTypes = {
    timezones: array.isRequired,
    timezone: string.isRequired,
    onTimezoneChange: func.isRequired,
    intl: intlShape.isRequired
  };

  static defaultProps = {
    timezones: [],
    timezone: null,
  };

  constructor(props) {
    super(props);

    const label = props.timezones.find(({ name }) => name === props.timezone);

    this.state = {
      open: false,
      selected: props.timezone ? props.timezone : props.webmasterTimezone,
      timezones: props.timezones.map(({ name, value }) => ({
        label: `${value} (${name.replace(/_/g, ' ')})`,
        value: name,
      })),
      label:
        label && label.value ? (
          label.value
        ) : (
          <FormattedMessage id="statistics.filters.timezone" defaultMessage="Timezone" />
        ),
    };
  }

  handleChange = selected => {
    this.setState(() => ({ selected }));
  };

  applyFilter = () => {
    this.setState(
      () => ({ open: false, label: this.getLabel() }),
      () => {
        const { selected } = this.state;
        const timeZone = !selected.value ? selected : selected.value;
        this.props.onTimezoneChange({ timeZone });
      },
    );
  };

  resetFilter = () => {
    const {webmasterTimezone} = this.props;
    this.setState(
      () => ({
        selected: webmasterTimezone,
        open: false,
        label: this.getLabel(true),
      }),
      () => {
        this.props.onTimezoneChange({ timeZone: webmasterTimezone });
      },
    );
  };

  toggle = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  getLabel = (reset = false) => {
    const { selected: timezone } = this.state;
    const { timezones, webmasterTimezone } = this.props;

    if (!reset && timezone && timezone.value) {
      const offset = timezones.find(({ name }) => timezone.value === name);

      return offset ? (
        offset.value
      ) : (
        <FormattedMessage id="statistics.filters.timezone" defaultMessage="Timezone" />
      );
    } else if(reset) {
      const offset = timezones.find(({ name }) => webmasterTimezone === name);
      if(offset) {
        return offset.value;
      }
    }

    return <FormattedMessage id="statistics.filters.timezone" defaultMessage="Timezone" />;
  };

  renderPlaceholder = () => {
    const {intl} = this.props;
    return intl.formatMessage({
      id: "main.select",
      defaultMessage: "Select..."
    });
  }

  render() {
    const { selected, timezones, open, label } = this.state;

    return (
      <Dropdown isOpen={open} toggle={this.toggle} tag="span">
        <DropdownToggle
          onClick={this.toggle}
          data-toggle="dropdown"
          aria-expanded={open}
          tag="span"
        >
          <Button
            size="sm"
            color="light"
            active={open}
            id="timezone-filter"
            onClick={this.toggle}
            outline
            className='btn-toggler'
          >
            {label}
            <i className="dropdown-toggle" />
            <span className="arrow" />
          </Button>
        </DropdownToggle>
        <DropdownMenu
          placement="bottom"
          className="filter-popover"
        >
          <Select
            alwaysOpened
            value={selected}
            options={timezones}
            onChange={this.handleChange}
            closeOnSelect={false}
            placeholder={this.renderPlaceholder()}
            clearable={false}
            openOnFocus
            autoFocus
          />

          <div className="filter-popover-controls">
            <Button type="button" size="sm" color="primary" onClick={this.applyFilter}>
              <FormattedMessage defaultMessage="Apply" id="statistics.filters.apply" />
            </Button>
            <Button type="button" size="sm" color="light" onClick={this.resetFilter}>
              <FormattedMessage defaultMessage="Reset" id="statistics.filters.reset" />
            </Button>
          </div>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

const mapStateToProps = ({ app, webmaster }) => ({
  timezones: app.globalSettings.timezones,
  webmasterTimezone: webmaster.profile.timezone
});

export default connect(mapStateToProps)(injectIntl(StatisticsTZSelector));
